import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVeFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_52713)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9994 19.5407H-0.000488281V9.4832C-0.000488281 9.00713 0.385546 8.62109 0.861619 8.62109H49.1374C49.6135 8.62109 49.9995 9.00713 49.9995 9.4832L49.9994 19.5407Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1373 41.3795H0.861619C0.385546 41.3795 -0.000488281 40.9934 -0.000488281 40.5174V30.46H49.9994V40.5174C49.9994 40.9935 49.6134 41.3795 49.1373 41.3795Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9994 19.54H-0.000488281V30.459H49.9994V19.54Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.3968 27.099L17.6128 27.7467L18.2955 27.752C18.3839 27.7527 18.4206 27.8655 18.3495 27.918L17.8003 28.3236L18.0063 28.9746C18.0329 29.0589 17.9369 29.1287 17.865 29.0772L17.3095 28.6801L16.754 29.0772C16.6821 29.1286 16.5861 29.0588 16.6127 28.9746L16.8187 28.3236L16.2694 27.918C16.1984 27.8656 16.235 27.7527 16.3235 27.752L17.0062 27.7467L17.2222 27.099C17.2502 27.0152 17.3689 27.0152 17.3968 27.099Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18.7232 25.0376L18.6075 25.7106L19.2067 26.0379C19.2843 26.0803 19.2633 26.1971 19.1758 26.2097L18.5 26.3075L18.3738 26.9785C18.3574 27.0653 18.24 27.0816 18.2009 27.0023L17.899 26.3898L17.2218 26.4772C17.1341 26.4885 17.0824 26.3817 17.1458 26.3199L17.6351 25.8436L17.3427 25.2266C17.3049 25.1467 17.3904 25.0646 17.4687 25.1058L18.0729 25.4238L18.5694 24.9551C18.6337 24.8944 18.7382 24.9505 18.7232 25.0376Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.402 23.2331L20.0815 23.836L20.5482 24.3343C20.6087 24.3989 20.5522 24.5032 20.4651 24.4877L19.7925 24.3693L19.4628 24.9672C19.4201 25.0446 19.3034 25.0232 19.2911 24.9357L19.196 24.2595L18.5254 24.1306C18.4385 24.1139 18.4229 23.9963 18.5024 23.9576L19.1161 23.6582L19.0314 22.9806C19.0204 22.8929 19.1274 22.8418 19.1888 22.9053L19.6632 23.3963L20.2814 23.1065C20.3617 23.069 20.4434 23.1549 20.402 23.2331Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.4218 22.113L21.9507 22.6073L22.2659 23.213C22.3068 23.2914 22.2242 23.3767 22.1444 23.3384L21.5288 23.043L21.05 23.5299C20.9881 23.593 20.8815 23.5407 20.8932 23.4531L20.9838 22.7763L20.3728 22.4714C20.2937 22.432 20.3103 22.3145 20.3972 22.2986L21.0689 22.1756L21.1699 21.5003C21.183 21.4129 21.2999 21.3924 21.3419 21.4702L21.6663 22.071L22.3399 21.9585C22.4273 21.9442 22.4827 22.049 22.4218 22.113Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.7437 21.5941L24.1574 21.9441L24.2988 22.612C24.3171 22.6985 24.2147 22.7586 24.1482 22.7004L23.6342 22.251L23.0425 22.5918C22.9659 22.636 22.8772 22.5572 22.9121 22.4759L23.1807 21.8481L22.6737 21.3907C22.6081 21.3316 22.6556 21.2229 22.7436 21.2309L23.4237 21.2923L23.702 20.6688C23.738 20.5881 23.8561 20.5996 23.8757 20.6858L24.0275 21.3515L24.7065 21.4235C24.7941 21.4329 24.8197 21.5487 24.7437 21.5941Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M32.6035 27.099L32.3875 27.7467L31.7048 27.752C31.6164 27.7527 31.5797 27.8655 31.6508 27.918L32.2 28.3236L31.994 28.9746C31.9674 29.0589 32.0634 29.1287 32.1353 29.0772L32.6908 28.6801L33.2463 29.0772C33.3181 29.1286 33.4141 29.0588 33.3876 28.9746L33.1816 28.3236L33.7308 27.918C33.8019 27.8656 33.7653 27.7527 33.6768 27.752L32.9941 27.7467L32.7781 27.099C32.7501 27.0152 32.6314 27.0152 32.6035 27.099Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M31.2775 25.0376L31.3932 25.7106L30.794 26.0379C30.7165 26.0803 30.7375 26.1971 30.825 26.2097L31.5008 26.3075L31.6269 26.9785C31.6433 27.0653 31.7608 27.0816 31.7999 27.0023L32.1017 26.3898L32.779 26.4772C32.8667 26.4885 32.9183 26.3817 32.855 26.3199L32.3657 25.8436L32.6581 25.2266C32.6959 25.1467 32.6103 25.0646 32.5321 25.1058L31.9279 25.4238L31.4313 24.9551C31.3671 24.8944 31.2626 24.9505 31.2775 25.0376Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M29.5986 23.2331L29.9191 23.836L29.4524 24.3343C29.392 24.3989 29.4484 24.5032 29.5356 24.4877L30.2081 24.3693L30.5379 24.9672C30.5806 25.0446 30.6973 25.0232 30.7096 24.9357L30.8047 24.2595L31.4753 24.1306C31.5621 24.1139 31.5777 23.9963 31.4982 23.9576L30.8846 23.6582L30.9692 22.9806C30.9803 22.8929 30.8732 22.8418 30.8118 22.9053L30.3374 23.3963L29.7192 23.1065C29.639 23.069 29.5572 23.1549 29.5986 23.2331Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.5784 22.113L28.0495 22.6073L27.7343 23.213C27.6935 23.2914 27.776 23.3767 27.8558 23.3384L28.4714 23.043L28.9502 23.5299C29.0121 23.593 29.1188 23.5407 29.107 23.4531L29.0163 22.7763L29.6274 22.4714C29.7065 22.432 29.6899 22.3145 29.603 22.2986L28.9313 22.1756L28.8302 21.5003C28.8171 21.4129 28.7002 21.3924 28.6582 21.4702L28.3338 22.071L27.6603 21.9585C27.573 21.9442 27.5175 22.049 27.5784 22.113Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.2569 21.5941L25.8432 21.9441L25.7018 22.612C25.6834 22.6985 25.7859 22.7586 25.8524 22.7004L26.3663 22.251L26.958 22.5918C27.0347 22.636 27.1234 22.5572 27.0885 22.4759L26.8199 21.8481L27.3269 21.3907C27.3925 21.3316 27.345 21.2229 27.257 21.2309L26.5769 21.2923L26.2986 20.6688C26.2625 20.5881 26.1445 20.5996 26.1248 20.6858L25.9731 21.3515L25.2941 21.4235C25.2065 21.4329 25.1809 21.5487 25.2569 21.5941Z",
					fill: "#F3F3F3"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_52713",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgVeFlag);
export { ForwardRef as ReactComponent };
